import { render, staticRenderFns } from "./EditTalentProfile.vue?vue&type=template&id=7a99c1ee"
import script from "./EditTalentProfile.vue?vue&type=script&lang=js"
export * from "./EditTalentProfile.vue?vue&type=script&lang=js"
import style0 from "./EditTalentProfile.vue?vue&type=style&index=0&id=7a99c1ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports